import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../components/Text'
import patient from '../stores/patient'
import request from '../utils/request'

const Box = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const Message = styled.span`
  font-size: 1.3rem;
  font-weight: 300;
  line-height: 200%;
`

@observer
export default class Logout extends Component {
  @observable noConnection = false
  attempts = 0

  @action
  setNoConnection = () => {
    this.noConnection = true
  }

  attemptLogout = async () => {
    const { history } = this.props
    const res = await request('/api/auth/logout')

    if (res.success) {
      history.replace('/')
    } else {
      this.attempts++

      if (this.attempts === 5) {
        this.setNoConnection()
      } else {
        setTimeout(this.attemptLogout, 1000)
      }
    }
  }

  componentDidMount() {
    patient.reset()
    this.attemptLogout()
  }

  render() {
    if (this.noConnection) {
      return (
        <Box>
          <Message><Text str="prose.couldntContactServer" /></Message>
          <Message><Text str="prose.checkConnectionReload" /></Message>
        </Box>
      )
    }

    return null
  }
}



// WEBPACK FOOTER //
// ./src/pages/Logout.js